export const ROUTES = {
  PORTFOLIO: '/portfolio',
  OVERVIEW: '/overview',
  CAMPAIGNS: '/campaigns',
  VOIDS: '/voids',
  ACCOUNTS: '/accounts',
  ITEMS: '/items',
  GROUPS: '/groups',
  FAVORITES: '/favorites',
  SCORECARDS: '/scorecards'
};

export const OTHER_ROUTES = {
  DETAILS: '/details',
  AUTH: '/auth',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CHANGE_BRAND: '/change-brand',
  REDIRECT_CMS_LOGIN: '/redirect-cms-login',
  CAMPAIGN_DETAILS: '/campaign-details',
  GROUP_DETAILS: '/group-details'
};
